import React from "react";
import ReactTable from 'react-table-v6'
import Moment from 'moment';
import { Component, Fragment } from "react";

import {
	Card,
	CardBody,
	CardTitle,
	Col,
	Row,
	Progress,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	ButtonGroup,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
  Form,
  FormGroup,
  Label,
	ButtonDropdown,
	DropdownToggle,
	DropdownItem,
	DropdownMenu,
	Fade
} from 'reactstrap';

import update from 'react-addons-update';
import 'c3/c3.css';
import 'react-table-v6/react-table.css'
import { authenticationService } from '../../../jwt/_services';

class QuotingOptions extends React.Component {

	constructor(props) {
    super(props);

		const currentUser = authenticationService.currentUserValue;
		console.log('currentUser info: ' + JSON.stringify(currentUser));
		console.log('currentUser info token: ' + JSON.stringify(currentUser.token));

    this.state = {
			repairCategories: [],
      repairOptions: [],
			repairBOM: [],
			bomData: [],
			productsData: [],
			marketsData: [],
			quoteData: [],
			tamData: [],
			productItemsForBOM: [],
			productItemsForQuoteItem: [],
			marketItemsForQuoteItem: [],
			productItemsForCategory: [],
			obj: {},
			modal: false,
      modal2: false,
			modal3: false,
			modal4: false,
			modal5: false,
			modal6: false,
			modal7: false,
			modal8: false,
			modal9: false,
			modal10: false,
			modal11: false,
			modal12: false,
			modal13: false,
			modal14: false,
			modal15: false,
			modal16: false,
			canEditCost: false,
			isOpen: false,
			currentItem: "ALL Markets",
			currentDataSetting: 100,
			isOpen2: false,
			currentItem2: "ALL Products",
			currentDataSetting2: 0,
			isOpen3: false,
			currentItem3: "ALL",
			currentDataSetting3: 0,
			marketSelected: 100,
			editPassword: "Azena589",
			ausEditPassword: "AusTech13!",
			europeEditPassword: "eu73Supp!",
			brazilEditPassword: "br89Supp!",
			taiwanEditPassword: "tw37Supp!",
			colombiaEditPassword: "co23Supp!",
			mexicoEditPassword: "mx23Supp!",
			czechEditPassword: "cz23Supp!",
			currencies: [{ Currency: "USD", Symbol: "$" }, { Currency: "EURO", Symbol: "€" }, { Currency: "AUD", Symbol: "$" }, { Currency: "TWD", Symbol: "$" }, { Currency: "COP", Symbol: "$" }, { Currency: "MXN", Symbol: "$" }, { Currency: "CZK", Symbol: "Kč" }],
			submitStatus: '',
			newSKU: "",
			newCost: "",
			newCurrency: "",
			newDescription: "",
			newCustomerNotes: "",
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			isInternationalTech: false,
			market: "us"
	  };

		this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
		this.onRadioBtnClick2 = this.onRadioBtnClick2.bind(this);

		this.toggle = this.toggle.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.toggle3 = this.toggle3.bind(this);
		this.toggle4 = this.toggle4.bind(this);
		this.toggle5 = this.toggle5.bind(this);
		this.toggle6 = this.toggle6.bind(this);
		this.toggle7 = this.toggle7.bind(this);
		this.toggle8 = this.toggle8.bind(this);
		this.toggle9 = this.toggle9.bind(this);
		this.toggle10 = this.toggle10.bind(this);
		this.toggle11 = this.toggle11.bind(this);
		this.toggle12 = this.toggle12.bind(this);
		this.toggle13 = this.toggle13.bind(this);
		this.toggle14 = this.toggle14.bind(this);
		this.toggle15 = this.toggle15.bind(this);
		this.toggle16 = this.toggle16.bind(this);

		this.toggleDropDown = this.toggleDropDown.bind(this);
		this.toggleDropDown2 = this.toggleDropDown2.bind(this);
		this.toggleDropDown3 = this.toggleDropDown3.bind(this);

		this.costOrSKUChange = this.costOrSKUChange.bind(this);
		this.onChangeAuthPassword = this.onChangeAuthPassword.bind(this);

  }

	async componentDidMount() {

		if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="europe") {
			this.setState({ currentItem: "Europe", marketSelected: 1, isInternationalTech: true });
		}

		if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="aus") {
			this.setState({ currentItem: "Australia", marketSelected: 2, isInternationalTech: true });
		}

		if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="brazil") {
			this.setState({ currentItem: "Brazil", marketSelected: 3, isInternationalTech: true });
		}

		if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="taiwan") {
			this.setState({ currentItem: "Taiwan", marketSelected: 4, isInternationalTech: true });
		}

		if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="colombia") {
			this.setState({ currentItem: "Colombia", marketSelected: 5, isInternationalTech: true });
		}

		if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="mexico") {
			this.setState({ currentItem: "Mexico", marketSelected: 6, isInternationalTech: true });
		}

		if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="czech") {
			this.setState({ currentItem: "Czech", marketSelected: 7, isInternationalTech: true });
		}

    //this.getCategoryData();
    //this.getOptionsData();
		await this.getMarketsData();
		this.getProductsData();
		//this.getBOMData();
		this.getQuoteData();
		//this.getTAMData();

		console.log('repair options currentUser email: ' + JSON.stringify(this.state.currentUser.payload.email));

		if (this.state.currentUser.payload.email == "jluo@azenamedical.com" || this.state.currentUser.payload.email == "hbrown@azenamedical.com" || this.state.currentUser.payload.email == "ryan.a.stickel@gmail.com") {
			this.setState({ canEditCost: true });
		}

		//canEditCost
	}

	async onRadioBtnClick(marketSelected) {
		await this.setState({ marketSelected, currentDataSetting: marketSelected });
		setTimeout(this.getQuoteData, 300);
	}

	async onRadioBtnClick2(currentDataSetting2) {

		await this.setState({ currentDataSetting2 });

		setTimeout(this.getQuoteData, 300);

	}

	toggle() {
	  this.setState({
	    modal: !this.state.modal
	  });
	}

  toggle2() {

	  this.setState({
	    modal2: !this.state.modal2
	  });
	}

	toggle3() {
	  this.setState({
	    modal3: !this.state.modal3
	  });
	}

	toggle4() {
	  this.setState({
	    modal4: !this.state.modal4
	  });
	}

	toggle5() {
	  this.setState({
	    modal5: !this.state.modal5
	  });
	}

	toggle6() {
	  this.setState({
	    modal6: !this.state.modal6
	  });
	}

	toggle7() {
	  this.setState({
	    modal7: !this.state.modal7
	  });
	}

	toggle8() {
	  this.setState({
	    modal8: !this.state.modal8
	  });
	}

	toggle9() {
	  this.setState({
	    modal9: !this.state.modal9
	  });
	}

	toggle10() {
	  this.setState({
	    modal10: !this.state.modal10
	  });
	}

	toggle11() {
	  this.setState({
	    modal11: !this.state.modal11
	  });
	}

	toggle12() {
	  this.setState({
	    modal12: !this.state.modal12
	  });
	}

	toggle13() {
	  this.setState({
	    modal13: !this.state.modal13
	  });
	}

	toggle14() {
	  this.setState({
	    modal14: !this.state.modal14
	  });
	}

	toggle15() {
	  this.setState({
	    modal15: !this.state.modal15
	  });
	}

	toggle16() {
	  this.setState({
	    modal16: !this.state.modal16
	  });
	}

	toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	toggleDropDown2() {
    this.setState({
      isOpen2: !this.state.isOpen2
    });
  }

	toggleDropDown3() {
    this.setState({
      isOpen3: !this.state.isOpen3
    });
  }

	selectDropDownItem(id, title) {

    this.setState({
      currentItem: title,
			currentDataSetting: id
    });

		setTimeout(this.getQuoteData, 300);

  }

	selectDropDownItem2(id, title) {

    this.setState({
      currentItem2: title,
			currentDataSetting2: id
    });

		setTimeout(this.getQuoteData, 300);

  }

	selectDropDownItem3(id, title) {

    this.setState({
      currentItem3: title,
			currentDataSetting3: id
    });

		setTimeout(this.getCategoryData, 300);

  }

	componentWillUnmount() {

	}

	goToRepairLog(id){
		window.location.href="/repair-log/"+id;
	}

	getCategoryData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-repair-categories?ProductID="+this.state.currentDataSetting3;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all repairCategories: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ repairCategories: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

  getOptionsData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-repair-options";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all repairOptions: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ repairOptions: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getBOMData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-bill-of-materials?ProductID="+this.state.currentDataSetting;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all BOM data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ bomData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getProductItemsForBOM = async (obj) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-product-items-for-bom?BomID="+obj.bomID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all productItemsForBOM data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ productItemsForBOM: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	deleteAllProductItemsForBOM = async (bomID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-product-items-for-bom?BomID="+bomID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all BOM data: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	addProductItemForBOM = async (bomID, productID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-product-item-for-bom?BomID="+bomID+"&ProductID="+productID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all BOM data: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getMarketItemsForQuoteItem = async (obj) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-product-items-for-quote-item?ForMarket=1&QuoteID="+obj.qItemID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all MarketItemsForQuoteItem data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ marketItemsForQuoteItem: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	addMarketItemForQuoteItem = async (quoteID, marketID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-product-item-for-quote-item?ForMarket=1&QuoteID="+quoteID+"&ProductID="+marketID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("add MarketItemForQuoteItem response: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	deleteAllMarketItemsForQuoteItem = async (quoteID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-product-items-for-quote-item?ForMarket=1&QuoteID="+quoteID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("MarketItemsForQuoteItem delete response: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getProductItemsForQuoteItem = async (obj) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-product-items-for-quote-item?QuoteID="+obj.qItemID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all ProductItemsForQuoteItem data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ productItemsForQuoteItem: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	deleteAllProductItemsForQuoteItem = async (quoteID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-product-items-for-quote-item?QuoteID="+quoteID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("ProductItemsForQuoteItem delete response: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	addProductItemForQuoteItem = async (quoteID, productID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-product-item-for-quote-item?QuoteID="+quoteID+"&ProductID="+productID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("add ProductItemForQuoteItem response: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getProductItemsForCategory = async (obj) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-product-items-for-category?CategoryID="+obj.categoryID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all ProductItemForCategory data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ productItemsForCategory: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	addProductItemForCategory = async (categoryID, productID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-product-item-for-category?CategoryID="+categoryID+"&ProductID="+productID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("add ProductItemForCategory response: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	deleteAllProductItemsForCategory = async (categoryID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-product-items-for-category?CategoryID="+categoryID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("ProductItemForCategory delete response: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getMarketsData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-markets";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all markets data: " + JSON.stringify(body));

			if (body.status == 'Success') {

				let userMarket = this.state.currentUser.payload['custom:market'];
				var marketsData = body.response;

				if (userMarket=='aus' || userMarket=='europe' || userMarket=='brazil' || userMarket=='taiwan' || userMarket=='colombia' || userMarket=='mexico' || userMarket=='czech') {
					marketsData = marketsData.filter(market => market.Abbreviation.includes(userMarket))
				}

				this.setState({ marketsData });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getProductsData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-products";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all Products data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ productsData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getQuoteData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-quote-items?ProductID="+this.state.currentDataSetting2;

		if (this.state.marketSelected != 100) {
			url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-quote-items?ProductID="+this.state.currentDataSetting2+"&MarketID="+this.state.marketSelected;
		}

		console.log("getQuoteData url: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all Quote data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ quoteData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	getTAMData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-tam-names";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all TAM data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ tamData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	createCategorySubmit = (event) => {
		event.preventDefault();

    let name = event.target.name.value;
    console.log(`name is:`, name);

		let products = Array.from(event.target.Products.selectedOptions, option => option.value);
    console.log(`products is:`, products);

		this.setState({
			modal5: !this.state.modal5
		})

    this.createCategory(name, products);
	}

  createCategory = async (name, products) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"create-repair-category?Name="+name;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("create category response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;

				var categoryID = body.response.insertId;

				for (var i=0; i<products.length; i++) {
					var product = products[i];
					await this.addProductItemForCategory(categoryID, product);
				}

				this.getCategoryData();
			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	createBOMSubmit = (event) => {
		event.preventDefault();

    let partNumber = event.target.PartNumber.value;
    console.log(`partNumber is:`, partNumber);

		let cost = event.target.Cost.value;
    console.log(`cost is:`, cost);

		let quantity = event.target.Quantity.value;
    console.log(`quantity is:`, quantity);

		let description = event.target.Description.value;
    console.log(`description is:`, description);

		//let products = event.target.Products.value;
		let products = Array.from(event.target.Products.selectedOptions, option => option.value);
    console.log(`products is:`, products);

		this.setState({
			modal11: !this.state.modal11
		})

    this.createBOM(partNumber, cost, quantity, description, products);
	}

  createBOM = async (partNumber, cost, quantity, description, products) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"create-bill-of-materials?PartNumber="+partNumber+"&Cost="+cost+"&Description="+description+"&Quantity="+quantity;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("create BOM response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;

				var bomID = body.response.insertId;

				for (var i=0; i<products.length; i++) {
					var product = products[i];
					await this.addProductItemForBOM(bomID, product);
				}

				// products.map((product, i) => {
				// 	this.addProductItemForBOM(bomID, product);
				// });

				this.getBOMData();
			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	createQuoteItemSubmit = (event) => {
		event.preventDefault();

    let sku = event.target.sku.value;
    console.log(`sku is:`, sku);

		let cost = event.target.Cost.value;
    console.log(`cost is:`, cost);

		// let quantity = event.target.Quantity.value;
    // console.log(`quantity is:`, quantity);

		let description = event.target.Description.value;
    console.log(`description is:`, description);

		let customerNotes = event.target.CustomerNotes.value;
    console.log(`customerNotes is:`, customerNotes);

		let products = Array.from(event.target.Products.selectedOptions, option => option.value);
    console.log(`products is:`, products);

		let markets = Array.from(event.target.Markets.selectedOptions, option => option.value);
    console.log(`markets is:`, markets);

		let authPassword = event.target.AuthPassword.value;
		console.log(`authPassword is:`, authPassword);

		var isAuthorized = false;

		if (authPassword == this.state.editPassword) {
			isAuthorized = true;
		}

		if (this.state.isInternationalTech) {

			if (this.state.currentUser.payload['custom:market']=="aus") {
				if (authPassword == this.state.ausEditPassword) {
					isAuthorized = true;
				}
			}

			if (this.state.currentUser.payload['custom:market']=="europe") {
				if (authPassword == this.state.europeEditPassword) {
					isAuthorized = true;
				}
			}

			if (this.state.currentUser.payload['custom:market']=="brazil") {
				if (authPassword == this.state.brazilEditPassword) {
					isAuthorized = true;
				}
			}

			if (this.state.currentUser.payload['custom:market']=="taiwan") {
				if (authPassword == this.state.taiwanEditPassword) {
					isAuthorized = true;
				}
			}

			if (this.state.currentUser.payload['custom:market']=="colombia") {
				if (authPassword == this.state.colombiaEditPassword) {
					isAuthorized = true;
				}
			}

			if (this.state.currentUser.payload['custom:market']=="mexico") {
				if (authPassword == this.state.mexicoEditPassword) {
					isAuthorized = true;
				}
			}

			if (this.state.currentUser.payload['custom:market']=="czech") {
				if (authPassword == this.state.czechEditPassword) {
					isAuthorized = true;
				}
			}

		}

		if (isAuthorized) {
			console.log(`Create is Authorized`);

			this.setState({
				modal13: !this.state.modal13
			})

	    this.createQuoteItem(sku, cost, description, customerNotes, products, markets);

		} else {
			console.log(`Create is NOT Authorized`);
			var submitStatus = "Incorrect Password. Password is required to create new Quote Item";
			this.setState({ submitStatus });
		}

	}

	createQuoteItem = async (sku, cost, description, customerNotes, products, markets) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"create-quote-item?SKU="+sku+"&Cost="+cost+"&Description="+description+"&CustomerNotes="+customerNotes;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("create Quote response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;

				var quoteID = body.response.insertId;

				for (var i=0; i<products.length; i++) {
					var product = products[i];
					await this.addProductItemForQuoteItem(quoteID, product);
				}

				for (var i=0; i<markets.length; i++) {
					var market = markets[i];
					await this.addMarketItemForQuoteItem(quoteID, market);
				}

				this.getQuoteData();
			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	createTAMSubmit = (event) => {
		event.preventDefault();

    let name = event.target.name.value;
    console.log(`name is:`, name);

		let phone = event.target.phone.value;
    console.log(`phone is:`, phone);

		this.setState({
			modal12: !this.state.modal12
		})

    this.createTAM(name, phone);
	}

  createTAM = async (name, phone) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"create-tam-names?Name="+name+"&Phone="+phone;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("create TAM response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;

				this.getTAMData();
			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	handleCategorySubmit = (event) => {
		event.preventDefault();
		let id = event.target.id.value;
    //console.log(`id:`, id);
	  let categoryID = event.target.categoryID.value;
    console.log(`categoryID is:`, categoryID);
    let name = event.target.name.value;
    console.log(`name is:`, name);

		let products = Array.from(event.target.Products.selectedOptions, option => option.value);
    console.log(`products is:`, products);

    //console.log(`role is:`, role);
		let newObj = JSON.parse(JSON.stringify(this.state.repairCategories));
    //console.log(`user copy is:`, newObj);
		//newObj[id] = [firstname, lastname, email, role];
    newObj[id] = {
			name: name
    }
		this.setState({
			repairCategories: newObj,
			modal: !this.state.modal
		})
    console.log("saved repairCategories is:", this.state.repairCategories[id].name);

    this.updateCategory(categoryID, name, products);
	}

  updateCategory = async (categoryID, name, products) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"edit-repair-category?CategoryID="+categoryID+"&Name="+name;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Update category response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;

				await this.deleteAllProductItemsForCategory(categoryID);

				for (var i=0; i<products.length; i++) {
					var product = products[i];
					await this.addProductItemForCategory(categoryID, product);
				}

				// products.map((product, i) => {
				// 	this.addProductItemForBOM(bomID, product);
				// });

				this.getCategoryData();

			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	deleteCategory = async () => {

		console.log("Delete Category: " + this.state.obj.name);

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-repair-category?CategoryID="+this.state.obj.categoryID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Delete category response: " + JSON.stringify(body.response));

			if (body.status == 'Success') {

				this.toggle2();
				this.getCategoryData();

			} else {


			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	deleteOption = async () => {

		console.log("Delete Category: " + this.state.obj.name);

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-repair-option?OptionID="+this.state.obj.optionID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Delete option response: " + JSON.stringify(body.response));

			if (body.status == 'Success') {

				this.toggle4();
				this.getOptionsData();

			} else {


			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	deleteBOM = async () => {

		console.log("Delete BOM: " + this.state.obj.PartNumber);

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-bill-of-materials?BomID="+this.state.obj.bomID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Delete BOM response: " + JSON.stringify(body.response));

			if (body.status == 'Success') {

				this.toggle8();
				await this.deleteAllProductItemsForBOM(this.state.obj.bomID);
				this.getBOMData();

			} else {


			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	deleteQuoteItem = async () => {

		console.log("Delete Quote: " + this.state.obj.SKU);

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-quote-item?QItemID="+this.state.obj.qItemID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Delete Quote response: " + JSON.stringify(body.response));

			if (body.status == 'Success') {

				this.toggle15();
				this.getQuoteData();

			} else {


			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	deleteTAM = async () => {

		console.log("Delete TAM: " + this.state.obj.name);

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-tam-names?TamID="+this.state.obj.tamID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Delete TAM response: " + JSON.stringify(body.response));

			if (body.status == 'Success') {

				this.toggle10();
				this.getTAMData();

			} else {


			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	createOptionSubmit = (event) => {
		event.preventDefault();

    let name = event.target.name.value;
    console.log(`name is:`, name);

		this.setState({
			modal6: !this.state.modal6
		})

    this.createOption(name);
	}

  createOption = async (name) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"create-repair-option?Name="+name;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("create option response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;
				this.getOptionsData();
			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	handleOptionSubmit = (event) => {
		event.preventDefault();
		let id = event.target.id.value;
    //console.log(`id:`, id);
	  let optionID = event.target.optionID.value;
    console.log(`optionID is:`, optionID);
    let name = event.target.name.value;
    console.log(`name is:`, name);

    //console.log(`role is:`, role);
		let newObj = JSON.parse(JSON.stringify(this.state.repairOptions));
    //console.log(`user copy is:`, newObj);
		//newObj[id] = [firstname, lastname, email, role];
    newObj[id] = {
			name: name
    }
		this.setState({
			repairOptions: newObj,
			modal3: !this.state.modal3
		})
    console.log("saved repairOptions is:", this.state.repairOptions[id].name);

    this.updateOption(optionID, name);
	}

  updateOption = async (optionID, name) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"edit-repair-option?OptionID="+optionID+"&Name="+name;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Update option response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;
			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	handleBOMSubmit = (event) => {
		event.preventDefault();
		let id = event.target.id.value;
    //console.log(`id:`, id);
	  let bomID = event.target.bomID.value;
    console.log(`bomID is:`, bomID);
    let partNumber = event.target.PartNumber.value;
    console.log(`partNumber is:`, partNumber);
		let cost = event.target.Cost.value;
    console.log(`cost is:`, cost);
		let quantity = event.target.Quantity.value;
    console.log(`quantity is:`, quantity);
		let description = event.target.Description.value;
    console.log(`description is:`, description);

		let products = Array.from(event.target.Products.selectedOptions, option => option.value);
    console.log(`products is:`, products);

    //console.log(`role is:`, role);
		let newObj = JSON.parse(JSON.stringify(this.state.bomData));
    //console.log(`user copy is:`, newObj);
		//newObj[id] = [firstname, lastname, email, role];
    newObj[id] = {
			PartNumber: partNumber,
			Cost: cost,
			Quantity: quantity,
			Description: description
    }
		this.setState({
			bomData: newObj,
			modal7: !this.state.modal7
		})
    console.log("saved bomData is:", this.state.bomData[id].PartNumber);

    this.updateBOM(bomID, partNumber, cost, quantity, description, products);
	}

  updateBOM = async (bomID, partNumber, cost, quantity, description, products) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"edit-bill-of-materials?BomID="+bomID+"&PartNumber="+partNumber+"&Cost="+cost+"&Description="+description+"&Quantity="+quantity;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Update bomData response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;

				await this.deleteAllProductItemsForBOM(bomID);

				for (var i=0; i<products.length; i++) {
					var product = products[i];
					await this.addProductItemForBOM(bomID, product);
				}

				// products.map((product, i) => {
				// 	this.addProductItemForBOM(bomID, product);
				// });

				this.getBOMData();

			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	handleQuoteItemSubmit = (event) => {
		event.preventDefault();
		let id = event.target.id.value;
    //console.log(`id:`, id);
	  let qItemID = event.target.qItemID.value;
    console.log(`qItemID is:`, qItemID);
    let sku = event.target.sku.value;
    console.log(`sku is:`, sku);
		let currency = event.target.Currency.value;
    console.log(`currency is:`, currency);
		let cost = event.target.Cost.value;
    console.log(`cost is:`, cost);
		// let quantity = event.target.Quantity.value;
    // console.log(`quantity is:`, quantity);
		let description = event.target.Description.value;
    console.log(`description is:`, description);

		let customerNotes = event.target.CustomerNotes.value;
    console.log(`customerNotes is:`, customerNotes);

		let products = Array.from(event.target.Products.selectedOptions, option => option.value);
    console.log(`products is:`, products);

		let markets = Array.from(event.target.Markets.selectedOptions, option => option.value);
    console.log(`markets is:`, markets);

		if (this.state.obj.sku!=this.state.newSKU || this.state.obj.Cost!=this.state.newCost || this.state.obj.Description!=this.state.newDescription || this.state.obj.Currency!=this.state.newCurrency || this.state.obj.CustomerNotes!=this.state.newCustomerNotes) {

			var authPassword = "";

			if (event.target.AuthPassword) {
				authPassword = event.target.AuthPassword.value;
			}

			console.log(`authPassword is:`, authPassword);

			var isAuthorized = false;

			if (authPassword == this.state.editPassword) {
				isAuthorized = true;
			}

			if (this.state.isInternationalTech) {

				if (this.state.currentUser.payload['custom:market']=="aus") {
					if (authPassword == this.state.ausEditPassword) {
						isAuthorized = true;
					}
				}

				if (this.state.currentUser.payload['custom:market']=="europe") {
					if (authPassword == this.state.europeEditPassword) {
						isAuthorized = true;
					}
				}

				if (this.state.currentUser.payload['custom:market']=="brazil") {
					if (authPassword == this.state.brazilEditPassword) {
						isAuthorized = true;
					}
				}

				if (this.state.currentUser.payload['custom:market']=="taiwan") {
					if (authPassword == this.state.taiwanEditPassword) {
						isAuthorized = true;
					}
				}

				if (this.state.currentUser.payload['custom:market']=="colombia") {
					if (authPassword == this.state.colombiaEditPassword) {
						isAuthorized = true;
					}
				}

				if (this.state.currentUser.payload['custom:market']=="mexico") {
					if (authPassword == this.state.mexicoEditPassword) {
						isAuthorized = true;
					}
				}

				if (this.state.currentUser.payload['custom:market']=="czech") {
					if (authPassword == this.state.czechEditPassword) {
						isAuthorized = true;
					}
				}

			}

			if (isAuthorized) {
				console.log(`Change is Authorized`);

				//console.log(`role is:`, role);
				let newObj = JSON.parse(JSON.stringify(this.state.quoteData));
		    //console.log(`user copy is:`, newObj);
				//newObj[id] = [firstname, lastname, email, role];
		    newObj[id] = {
					SKU: sku,
					Cost: cost,
					Currency: currency,
					Description: description,
					CustomerNotes: customerNotes
		    }
				this.setState({
					quoteData: newObj,
					modal14: !this.state.modal14
				})
		    console.log("saved quoteData is:", this.state.quoteData[id].SKU);

		    this.updateQuoteItem(qItemID, sku, currency, cost, description, customerNotes, products, markets);

			} else {
				console.log(`Change is NOT Authorized`);
				var submitStatus = "Incorrect Password. Password is required for changes to: SKU, Description, Cost";
				this.setState({ submitStatus });
			}

		} else {

			//console.log(`role is:`, role);
			let newObj = JSON.parse(JSON.stringify(this.state.quoteData));
	    //console.log(`user copy is:`, newObj);
			//newObj[id] = [firstname, lastname, email, role];
	    newObj[id] = {
				SKU: sku,
				Cost: cost,
				Currency: currency,
				Description: description,
				CustomerNotes: customerNotes
	    }
			this.setState({
				quoteData: newObj,
				modal14: !this.state.modal14
			})
	    console.log("saved quoteData is:", this.state.quoteData[id].SKU);

	    this.updateQuoteItem(qItemID, sku, currency, cost, description, customerNotes, products, markets);

		}
	}

	updateQuoteItem = async (qItemID, sku, currency, cost, description, customerNotes, products, markets) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"edit-quote-item?QItemID="+qItemID+"&SKU="+sku+"&Currency="+currency+"&Cost="+cost+"&Description="+description+"&CustomerNotes="+customerNotes;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Update quote item response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;

				await this.deleteAllProductItemsForQuoteItem(qItemID);
				await this.deleteAllMarketItemsForQuoteItem(qItemID);

				for (var i=0; i<products.length; i++) {
					var product = products[i];
					await this.addProductItemForQuoteItem(qItemID, product);
				}

				for (var i=0; i<markets.length; i++) {
					var market = markets[i];
					await this.addMarketItemForQuoteItem(qItemID, market);
				}

				// products.map((product, i) => {
				// 	this.addProductItemForBOM(bomID, product);
				// });

				this.getQuoteData();

			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	handleTAMSubmit = (event) => {
		event.preventDefault();
		let id = event.target.id.value;
    //console.log(`id:`, id);
	  let tamID = event.target.tamID.value;
    console.log(`tamID is:`, tamID);
    let name = event.target.name.value;
    console.log(`name is:`, name);
		let phone = event.target.phone.value;
    console.log(`phone is:`, phone);

    //console.log(`role is:`, role);
		let newObj = JSON.parse(JSON.stringify(this.state.tamData));
    //console.log(`user copy is:`, newObj);
		//newObj[id] = [firstname, lastname, email, role];
    newObj[id] = {
			name: name,
			phone: phone
    }
		this.setState({
			tamData: newObj,
			modal9: !this.state.modal9
		})
    console.log("saved tamData is:", this.state.tamData[id].name);

    this.updateTAM(tamID, name, phone);
	}

  updateTAM = async (tamID, name, phone) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"edit-tam-names?TamID="+tamID+"&Name="+name+"&Phone="+phone;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Update tamData response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;
			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	filterCaseInsensitive(filter, row) {
		const id = filter.pivotId || filter.id;

		console.log("filterCaseInsensitive row[id]: " + JSON.stringify(id));

		if (id == 'datecreated') {
			var dateString = Moment(row[id]).format('MMM Do YYYY');
			return (
					dateString !== undefined ?
							String(dateString.toString().toLowerCase()).includes(filter.value.toLowerCase())
					:
							true
			);
		}

		if (row[id] !== null){
			return (
					row[id] !== undefined ?
							String(row[id].toString().toLowerCase()).includes(filter.value.toLowerCase())
					:
							true
			);
		}
	}

	costOrSKUChange = (event) => {

		console.log("costOrSKUChange input id: " + event.target.id);
		console.log("costOrSKUChange input value: " + event.target.value);

		let id = event.target.id;
		let value = event.target.value;

		this.setState({
			newSKU: document.getElementById("sku").value,
			newCost: document.getElementById("Cost").value,
			newCurrency: document.getElementById("Currency").value,
			newDescription: document.getElementById("Description").value,
			newCustomerNotes: document.getElementById("CustomerNotes").value,
		});

		if (this.state.submitStatus) {
			this.setState({
				submitStatus: '',
			});
		}

	}

	onChangeAuthPassword = (event) => {

		// console.log("costOrPartNumberChange input id: " + event.target.id);
		// console.log("costOrPartNumberChange input value: " + event.target.value);
		//
		// let id = event.target.id;
		// let value = event.target.value;

		if (this.state.submitStatus) {
			this.setState({
				submitStatus: '',
			});
		}

	}


  render() {

		var isForeignUser = false;

		if (this.state.currentUser.payload['custom:market'] && (this.state.currentUser.payload['custom:market']=="europe" || this.state.currentUser.payload['custom:market']=="aus" || this.state.currentUser.payload['custom:market']=="brazil" || this.state.currentUser.payload['custom:market']=="taiwan" || this.state.currentUser.payload['custom:market']=="colombia" || this.state.currentUser.payload['custom:market']=="mexico" || this.state.currentUser.payload['custom:market']=="czech")) {
			isForeignUser = true;
		}

		const data5 = this.state.quoteData.map((prop, key) => {

			//const buf = Buffer.from(prop.detailedissue, 'utf8');

			//buf.toString(); // 'Hello, World'

			var currencyObject = this.state.currencies[prop.Currency-1];

			var costWithSymbol = this.state.currencies[prop.Currency-1].Symbol + prop.Cost;

			return {
				id: key,
				MarketName: prop.marketName,
				qItemID: prop.id,
				sku: prop.SKU,
        Cost: prop.Cost,
				CostWithSymbol: costWithSymbol,
				Quantity: prop.Quantity,
				ProductName: prop.productName,
				Description: prop.Description,
				CustomerNotes: prop.CustomerNotes,
				Currency: prop.Currency,
				CurrencyObject: currencyObject,
				actions: (
					// we've added some custom button actions
					<div className="text-center">
						{/* use this button to add a edit kind of action */}
						<Button
							onClick={() => {
								let obj = data5.find(o => o.id === key);
                console.log('button obj: ' + obj);
								this.setState({
									modal14: !this.state.modal14,
									obj: obj,
									newSKU: obj.sku,
									newCost: obj.Cost,
									newCurrency: obj.Currency,
									newDescription: obj.Description,
									newCustomerNotes: obj.CustomerNotes,
								});
								//this.showVerification(obj);
								this.getProductItemsForQuoteItem(obj);
								this.getMarketItemsForQuoteItem(obj);
							}}
							color="yellow"
							size="sm"
							round="true"
							icon="true"
						>
							<i className="fa fa-edit" />
						</Button>
						<Button
							onClick={() => {
								let obj = data5.find(o => o.id === key);
                console.log('button obj: ' + obj);
								this.setState({
									modal15: !this.state.modal15,
									obj: obj
								});
							}}
							color="danger"
							size="sm"
							round="true"
							icon="true"
							className="ml-2"
						>
							<i className="fa fa-trash-alt" />
						</Button>
						{/* use this button to remove the data row */}
						{/* <Button
							onClick={() => {
								let obj = data2.find(o => o.id === key);
                console.log('button obj: ' + obj);
								this.setState({
									modal4: !this.state.modal4,
									obj: obj
								});
							}}
							color="danger"
							size="sm"
							round="true"
							icon="true"
							className="ml-2"
						>
							<i className="fa fa-trash-alt" />
						</Button> */}
					</div>
				)
			};
		});

		return (
      <Fragment>
					<Row>
						<Col xs="12" md="12" lg="12">
							<Card className="card-hover">
								<CardBody>
									<Row className="mb-3 align-items-start">
										<Col xs="12" lg="6" className="mb-3 mb-lg-0">
											{this.state.marketSelected==100 && (
												<Fade in="true">
													<h3 style={{ color:'#737782', marginBottom: 0 }}>ALL Quoting Options</h3>
												</Fade>
											)}
											{this.state.marketSelected==0 && (
												<Fade in="true">
													<h3 style={{ color:'#737782', marginBottom: 0 }}>US Quoting Options</h3>
												</Fade>
											)}
											{this.state.marketSelected==1 && (
												<Fade in="true">
													<h3 style={{ color:'#737782', marginBottom: 0 }}>Europe Quoting Options</h3>
												</Fade>
											)}
											{this.state.marketSelected==2 && (
												<Fade in="true">
													<h3 style={{ color:'#737782', marginBottom: 0 }}>Australia Quoting Options</h3>
												</Fade>
											)}
											{this.state.marketSelected==3 && (
												<Fade in="true">
													<h3 style={{ color:'#737782', marginBottom: 0 }}>Brazil Quoting Options</h3>
												</Fade>
											)}
											{this.state.marketSelected==4 && (
												<Fade in="true">
													<h3 style={{ color:'#737782', marginBottom: 0 }}>Taiwan Quoting Options</h3>
												</Fade>
											)}
											{this.state.marketSelected==5 && (
												<Fade in="true">
													<h3 style={{ color:'#737782', marginBottom: 0 }}>Colombia Quoting Options</h3>
												</Fade>
											)}
											{this.state.marketSelected==6 && (
												<Fade in="true">
													<h3 style={{ color:'#737782', marginBottom: 0 }}>Mexico Quoting Options</h3>
												</Fade>
											)}
											{this.state.marketSelected==7 && (
												<Fade in="true">
													<h3 style={{ color:'#737782', marginBottom: 0 }}>Czech Quoting Options</h3>
												</Fade>
											)}
										</Col>

										<Col xs="12" lg="6">
											<div
												className="d-flex flex-wrap justify-content-lg-end"
												style={{ gap: '10px' }}
											>
												<Button color="yellow" onClick={this.toggle13}>
													Create New Quoting Item
												</Button>
											</div>
										</Col>
										</Row>

										{!isForeignUser && (
										<Row className="mb-3">
											<Col xs="12">
												<Label style={{ fontSize: '14px', marginBottom: '6px' }}>Markets</Label>
												<ButtonGroup style={{ width: '100%', flexWrap: 'wrap' }}>
													<Button
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick(100)}
														active={this.state.marketSelected === 100}
													>
														ALL Quoting Options
													</Button>
													<Button
														className="ml-1 mt-1 mt-sm-0"
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick(0)}
														active={this.state.marketSelected === 0}
													>
														US
													</Button>
													<Button
														className="ml-1 mt-1 mt-sm-0"
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick(1)}
														active={this.state.marketSelected === 1}
													>
														Europe
													</Button>
													<Button
														className="ml-1 mt-1 mt-sm-0"
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick(2)}
														active={this.state.marketSelected === 2}
													>
														Australia
													</Button>
													<Button
														className="ml-1 mt-1 mt-sm-0"
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick(3)}
														active={this.state.marketSelected === 3}
													>
														Brazil
													</Button>
													<Button
														className="ml-1 mt-1 mt-sm-0"
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick(4)}
														active={this.state.marketSelected === 4}
													>
														Taiwan
													</Button>
													<Button
														className="ml-1 mt-1 mt-sm-0"
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick(5)}
														active={this.state.marketSelected === 5}
													>
														Colombia
													</Button>
													<Button
														className="ml-1 mt-1 mt-sm-0"
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick(6)}
														active={this.state.marketSelected === 6}
													>
														Mexico
													</Button>
													<Button
														className="ml-1 mt-1 mt-sm-0"
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick(7)}
														active={this.state.marketSelected === 7}
													>
														Czech
													</Button>
												</ButtonGroup>
											</Col>
										</Row>
										)}

										<Row className="mb-3">
										<Col xs="12" lg="3" />
										<Col xs="12" lg="6">
											<Label style={{ fontSize: '14px', marginBottom: '6px' }}>Products</Label>
											<ButtonGroup style={{ width: '100%', flexWrap: 'wrap' }}>
												<Button
													style={{ flex: '1 1 auto' }}
													color="btngray"
													onClick={() => this.onRadioBtnClick2(0)}
													active={this.state.currentDataSetting2 === 0}
												>
													ALL Products
												</Button>
												{this.state.productsData.map((product, i) => (
													<Button
														key={product.id || i}
														className="ml-1 mt-1 mt-sm-0"
														style={{ flex: '1 1 auto' }}
														color="btngray"
														onClick={() => this.onRadioBtnClick2(product.id)}
														active={this.state.currentDataSetting2 === product.id}
													>
														{product.Name}
													</Button>
												))}
											</ButtonGroup>
										</Col>
										<Col xs="12" lg="3" />
									</Row>
									<div style={{ width: '100%', overflowX: 'auto' }}>
									<ReactTable
										style={{backgroundColor:'#000', padding:'10px', autocomplete: 'none'}}
										columns={[
											{
										    Header: "Location / Market",
										    accessor: "MarketName",
										    minWidth: 180,
										    maxWidth: 240,
										    style: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
										    Cell: row => (
										      <div style={{ textAlign: "center" }}>{row.value}</div>
										    )
										  },
										  {
										    Header: "SKU",
										    accessor: "sku",
										    minWidth: 140,
										    maxWidth: 180,
										    style: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
										    Cell: row => (
										      <div style={{ textAlign: "center" }}>{row.value}</div>
										    )
										  },
										  {
										    Header: "Currency",
										    accessor: "CurrencyObject",
										    minWidth: 110,
										    maxWidth: 140,
										    style: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
										    Cell: row => (
										      <div style={{ textAlign: "center" }}>{row.value.Currency}</div>
										    )
										  },
										  {
										    Header: "Cost",
										    accessor: "CostWithSymbol",
										    minWidth: 110,
										    maxWidth: 140,
										    style: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
										    Cell: row => (
										      <div style={{ textAlign: "center" }}>{row.value}</div>
										    )
										  },
										  {
										    Header: "Description",
										    accessor: "Description",
										    minWidth: 260,
										    maxWidth: 380,
										    style: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
										    Cell: row => (
										      <div style={{ textAlign: "center" }}>{row.value}</div>
										    )
										  },
										  {
										    Header: "Customer Notes",
										    accessor: "CustomerNotes",
										    minWidth: 260,
										    maxWidth: 380,
										    style: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
										    Cell: row => (
										      <div style={{ textAlign: "center" }}>{row.value}</div>
										    )
										  },
										  {
										    Header: "Actions",
										    accessor: "actions",
										    minWidth: 140,
										    maxWidth: 180,
										    sortable: false,
										    filterable: false,
										    style: { display: 'flex', flexDirection: 'column', justifyContent: 'center' }
										  }
										]}
										defaultPageSize={14}
										sortable={true}
										showPaginationBottom={true}
										className="-striped -highlight"
										data={data5}
										filterable
										filterAll={true}
										defaultFilterMethod={(filter, row) => this.filterCaseInsensitive(filter, row) }
										getTrGroupProps={(state, rowInfo, column, instance) => {
														if (rowInfo !== undefined) {
																return {
																		onClick: (e, handleOriginal) => {
																			console.log('It was in this row:', rowInfo)
																			console.log('with ID:', rowInfo.original.categoryID);

																			//this.goToRepairLog(rowInfo.original.repairId);
																		},
																		style: {
																				cursor: 'pointer'
																		}
																}
														}}
												}
									/>
									</div>
								</CardBody>
							</Card>
		        </Col>
		      </Row>
			<div>
				<Modal isOpen={this.state.modal} toggle={this.toggle}>
					<ModalHeader toggle={this.toggle}>Edit Repair Reason</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.handleCategorySubmit}>
							<Input type="hidden" name="id" id="id" defaultValue={this.state.obj.id}/>
							<Input type="hidden" name="categoryID" id="categoryID" defaultValue={this.state.obj.categoryID}/>
							<FormGroup>
								<Label for="firstname">Name</Label>
								<Input type="text" name="name" id="name" defaultValue={this.state.obj.name}/>
							</FormGroup>
							<FormGroup>
								<Label for="Products">Select Products</Label>
								<Input id="Products" multiple name="Products" type="select">
								{this.state.productsData.map((product, i) => {

									var productItem = this.state.productItemsForCategory.find(p => p.ProductID === product.id);

									console.log('product: ', product.id);
									console.log('productItem: ', productItem);

									if (productItem) {
										return (
											<option value={product.id} selected>{product.Name}</option>
										);
									} else {
										return (
											<option value={product.id}>{product.Name}</option>
										);
									}

								})}
								</Input>
							</FormGroup>
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal2} toggle={this.toggle2}>
  				<ModalHeader toggle={this.toggle2}>Delete Repair Reason</ModalHeader>
  				<ModalBody>
						<span>Are you sure you want to delete this Category?</span>
  				</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.deleteCategory}>Yes</Button>
						<Button color="secondary" className="ml-1" onClick={this.toggle2}>Cancel</Button>
					</ModalFooter>
			  </Modal>
				<Modal isOpen={this.state.modal3} toggle={this.toggle3}>
					<ModalHeader toggle={this.toggle3}>Edit Repair Option</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.handleOptionSubmit}>
							<Input type="hidden" name="id" id="id" defaultValue={this.state.obj.id}/>
							<Input type="hidden" name="optionID" id="optionID" defaultValue={this.state.obj.optionID}/>
							<FormGroup>
								<Label for="firstname">Name</Label>
								<Input type="text" name="name" id="name" defaultValue={this.state.obj.name}/>
							</FormGroup>
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle3}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal4} toggle={this.toggle4}>
  				<ModalHeader toggle={this.toggle4}>Delete Repair Option</ModalHeader>
  				<ModalBody>
						<span>Are you sure you want to delete this Option?</span>
  				</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.deleteOption}>Yes</Button>
						<Button color="secondary" className="ml-1" onClick={this.toggle4}>Cancel</Button>
					</ModalFooter>
			  </Modal>
				<Modal isOpen={this.state.modal5} toggle={this.toggle5}>
					<ModalHeader toggle={this.toggle5}>Create Repair Reason</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.createCategorySubmit}>
							<FormGroup>
								<Label for="firstname">Name</Label>
								<Input type="text" name="name" id="name" defaultValue={this.state.obj.name}/>
							</FormGroup>
							<FormGroup>
								<Label for="Products">Select Products</Label>
								<Input id="Products" multiple name="Products" type="select">
									{this.state.productsData.map((product, i) => (
										<option value={product.id}>{product.Name}</option>
									))}
								</Input>
							</FormGroup>
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle5}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal6} toggle={this.toggle6}>
					<ModalHeader toggle={this.toggle6}>Create Repair Option</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.createOptionSubmit}>
							<FormGroup>
								<Label for="firstname">Name</Label>
								<Input type="text" name="name" id="name" defaultValue={this.state.obj.name}/>
							</FormGroup>
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle6}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal7} toggle={this.toggle7}>
					<ModalHeader toggle={this.toggle7}>Edit Part</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.handleBOMSubmit}>
							<Input type="hidden" name="id" id="id" defaultValue={this.state.obj.id}/>
							<Input type="hidden" name="bomID" id="bomID" defaultValue={this.state.obj.bomID}/>
							<FormGroup>
								<Label for="PartNumber">Part Number</Label>
								<Input type="text" name="PartNumber" id="PartNumber" defaultValue={this.state.obj.PartNumber}/>
							</FormGroup>
							<FormGroup>
								<Label for="Cost">Cost</Label>
								<Input type="text" name="Cost" id="Cost" defaultValue={this.state.obj.Cost}/>
							</FormGroup>
							<FormGroup>
								<Label for="Cost">Quantity</Label>
								<Input type="text" name="Quantity" id="Quantity" defaultValue={this.state.obj.Quantity}/>
							</FormGroup>
							<FormGroup>
								<Label for="Description">Description</Label>
								<Input type="text" name="Description" id="Description" defaultValue={this.state.obj.Description}/>
							</FormGroup>
							<FormGroup>
						    <Label for="Products">Select Products</Label>
						    <Input id="Products" multiple name="selectMulti" type="select">
									{
										// {this.state.productsData.map((product, i) => (
										// 	<option value={product.id}>{product.Name}</option>
										// ))}
									}

									{this.state.productsData.map((product, i) => {

										var productItem = this.state.productItemsForBOM.find(p => p.ProductID === product.id);

										console.log('product: ', product.id);
										console.log('productItem: ', productItem);

										if (productItem) {
											return (
												<option value={product.id} selected>{product.Name}</option>
											);
										} else {
											return (
												<option value={product.id}>{product.Name}</option>
											);
										}

									})}
						    </Input>
						  </FormGroup>
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle7}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal8} toggle={this.toggle8}>
  				<ModalHeader toggle={this.toggle8}>Delete Part</ModalHeader>
  				<ModalBody>
						<span>Are you sure you want to delete this Part?</span>
  				</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.deleteBOM}>Yes</Button>
						<Button color="secondary" className="ml-1" onClick={this.toggle8}>Cancel</Button>
					</ModalFooter>
			  </Modal>
				<Modal isOpen={this.state.modal9} toggle={this.toggle9}>
					<ModalHeader toggle={this.toggle9}>Edit TAM Names</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.handleTAMSubmit}>
							<Input type="hidden" name="id" id="id" defaultValue={this.state.obj.id}/>
							<Input type="hidden" name="tamID" id="tamID" defaultValue={this.state.obj.tamID}/>
							<FormGroup>
								<Label for="name">Name</Label>
								<Input type="text" name="name" id="name" defaultValue={this.state.obj.name}/>
							</FormGroup>
							<FormGroup>
								<Label for="phone">Phone Number</Label>
								<Input type="text" name="phone" id="phone" defaultValue={this.state.obj.phone}/>
							</FormGroup>
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle9}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal10} toggle={this.toggle10}>
  				<ModalHeader toggle={this.toggle10}>Delete TAM Name</ModalHeader>
  				<ModalBody>
						<span>Are you sure you want to delete this TAM name?</span>
  				</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.deleteTAM}>Yes</Button>
						<Button color="secondary" className="ml-1" onClick={this.toggle10}>Cancel</Button>
					</ModalFooter>
			  </Modal>
				<Modal isOpen={this.state.modal11} toggle={this.toggle11}>
					<ModalHeader toggle={this.toggle11}>Create Part</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.createBOMSubmit}>
							<FormGroup>
								<Label for="PartNumber">Part Number</Label>
								<Input type="text" name="PartNumber" id="PartNumber"/>
							</FormGroup>
							<FormGroup>
								<Label for="Cost">Cost</Label>
								<Input type="text" name="Cost" id="Cost"/>
							</FormGroup>
							<FormGroup>
								<Label for="Quantity">Quantity</Label>
								<Input type="text" name="Quantity" id="Quantity"/>
							</FormGroup>
							<FormGroup>
								<Label for="Description">Description</Label>
								<Input type="text" name="Description" id="Description"/>
							</FormGroup>
							<FormGroup>
						    <Label for="Products">Select Products</Label>
						    <Input id="Products" multiple name="Products" type="select">
									{this.state.productsData.map((product, i) => (
										<option value={product.id}>{product.Name}</option>
									))}
						    </Input>
						  </FormGroup>
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle11}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal12} toggle={this.toggle12}>
					<ModalHeader toggle={this.toggle12}>Create Tam Name</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.createTAMSubmit}>
							<FormGroup>
								<Label for="name">Name</Label>
								<Input type="text" name="name" id="name"/>
							</FormGroup>
							<FormGroup>
								<Label for="phone">Phone Number</Label>
								<Input type="text" name="phone" id="phone"/>
							</FormGroup>
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle12}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal13} toggle={this.toggle13}>
					<ModalHeader toggle={this.toggle13}>Create New Quoting Item</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.createQuoteItemSubmit}>
							<FormGroup>
								<Label for="PartNumber">SKU</Label>
								<Input type="text" name="PartNumber" id="sku"/>
							</FormGroup>
							<FormGroup>
								<Label for="Currency">Currency</Label>
								<Input id="Currency" name="Currency" type="select">
									{this.state.currencies.map((currency, i) => {

										return (
											<option value={i+1}>{currency.Currency}</option>
										);

									})}
								</Input>
							</FormGroup>
							<FormGroup>
								<Label for="Cost">Cost</Label>
								<Input type="text" name="Cost" id="Cost"/>
							</FormGroup>
							<FormGroup>
								<Label for="Description">Description</Label>
								<Input type="text" name="Description" id="Description"/>
							</FormGroup>
							<FormGroup>
								<Label for="CustomerNotes">Customer Notes</Label>
								<Input type="text" name="CustomerNotes" id="CustomerNotes" autocomplete="new-text"/>
							</FormGroup>
							<Row>
								<Col md="6">
									<FormGroup>
								    <Label for="Products">Select Products</Label>
								    <Input id="Products" multiple name="Products" type="select">
											{this.state.productsData.map((product, i) => {

												return (
													<option value={product.id}>{product.Name}</option>
												);

											})}
								    </Input>
								  </FormGroup>
								</Col>
								<Col md="6">
									<FormGroup>
								    <Label for="Markets">Select Markets</Label>
								    <Input id="Markets" multiple name="Markets" type="select" disabled={isForeignUser}>
											{this.state.marketsData.map((market, i) => {

												if (this.state.currentUser.payload['custom:market'] && (this.state.currentUser.payload['custom:market']=="europe" || this.state.currentUser.payload['custom:market']=="aus" || this.state.currentUser.payload['custom:market']=="brazil" || this.state.currentUser.payload['custom:market']=="taiwan" || this.state.currentUser.payload['custom:market']=="colombia" || this.state.currentUser.payload['custom:market']=="mexico" || this.state.currentUser.payload['custom:market']=="czech")) {
													return (
														<option value={market.id} selected>{market.Name}</option>
													);
												} else {
													return (
														<option value={market.id}>{market.Name}</option>
													);
												}

											})}
								    </Input>
								  </FormGroup>
								</Col>
							</Row>
							<FormGroup>
								<Label style={{fontSize:'18px'}} for="AuthPassword">Authorization Password</Label>
								<Input type="password" name="AuthPassword" id="AuthPassword" placeholder="Password" onChange={this.onChangeAuthPassword} autocomplete="new-password"/>
							</FormGroup>
							{this.state.submitStatus &&
								<div className={'alert alert-danger'}>{this.state.submitStatus}</div>
							}
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle13}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal14} toggle={this.toggle14}>
					<ModalHeader toggle={this.toggle14}>Edit Quote Item</ModalHeader>
					<ModalBody>
						<Form onSubmit={this.handleQuoteItemSubmit}>
							<Input type="hidden" name="id" id="id" defaultValue={this.state.obj.id}/>
							<Input type="hidden" name="qItemID" id="qItemID" defaultValue={this.state.obj.qItemID}/>
							<FormGroup>
								<Label for="sku">SKU</Label>
								<Input type="text" name="sku" id="sku" defaultValue={this.state.obj.sku} onChange={this.costOrSKUChange}/>
							</FormGroup>
							<FormGroup>
								<Label for="Currency">Currency {this.state.obj.Currency}</Label>
								<Input id="Currency" name="Currency" type="select" defaultValue={this.state.obj.Currency} onChange={this.costOrSKUChange}>
									{this.state.currencies.map((currency, i) => {

										return (
											<option value={i+1}>{currency.Currency}</option>
										);

									})}
								</Input>
							</FormGroup>
							<FormGroup>
								<Label for="Cost">Cost</Label>
								<Input type="text" name="Cost" id="Cost" defaultValue={this.state.obj.Cost} onChange={this.costOrSKUChange}/>
							</FormGroup>
							<FormGroup>
								<Label for="Description">Description</Label>
								<Input type="text" name="Description" id="Description" defaultValue={this.state.obj.Description} onChange={this.costOrSKUChange}/>
							</FormGroup>
							<FormGroup>
								<Label for="CustomerNotes">Customer Notes</Label>
								<Input type="text" name="CustomerNotes" id="CustomerNotes" defaultValue={this.state.obj.CustomerNotes} onChange={this.costOrSKUChange}/>
							</FormGroup>
							<Row>
								<Col md="6">
									<FormGroup>
								    <Label for="Products">Select Products</Label>
								    <Input id="Products" multiple name="Products" type="select">
										{this.state.productsData.map((product, i) => {

											var productItem = this.state.productItemsForQuoteItem.find(p => p.ProductID === product.id);

											console.log('product: ', product.id);
											console.log('productItem: ', productItem);

											if (productItem) {
												return (
													<option value={product.id} selected>{product.Name}</option>
												);
											} else {
												return (
													<option value={product.id}>{product.Name}</option>
												);
											}

										})}
								    </Input>
								  </FormGroup>
								</Col>
								<Col md="6">
									<FormGroup>
										<Label for="Markets">Select Markets</Label>
										<Input id="Markets" multiple name="Markets" type="select" disabled={isForeignUser}>
										{this.state.marketsData.map((market, i) => {

											var marketItem = this.state.marketItemsForQuoteItem.find(m => m.MarketID === market.id);

											console.log('market: ', market.id);
											console.log('marketItem: ', marketItem);

											if (marketItem) {
												return (
													<option value={market.id} selected>{market.Name}</option>
												);
											} else {
												return (
													<option value={market.id}>{market.Name}</option>
												);
											}

										})}
										</Input>
									</FormGroup>
								</Col>
							</Row>
							{(this.state.obj.Cost != this.state.newCost || this.state.obj.sku != this.state.newSKU || this.state.obj.Description!=this.state.newDescription || this.state.obj.Currency!=this.state.newCurrency || this.state.obj.CustomerNotes!=this.state.newCustomerNotes) &&
								<FormGroup>
									<Label style={{fontSize:'18px'}} for="AuthPassword">Authorization Password</Label>
									<Input type="password" name="AuthPassword" id="AuthPassword" placeholder="Password" onChange={this.onChangeAuthPassword} autocomplete="new-password"/>
								</FormGroup>
							}
							{this.state.submitStatus &&
								<div className={'alert alert-danger'}>{this.state.submitStatus}</div>
							}
							<FormGroup>
								<Button color="primary" type="submit">Save</Button>
								<Button color="secondary" className="ml-1" onClick={this.toggle14}>Cancel</Button>
							</FormGroup>
						</Form>
					</ModalBody>
				</Modal>
				<Modal isOpen={this.state.modal15} toggle={this.toggle15}>
  				<ModalHeader toggle={this.toggle15}>Delete Quote Item</ModalHeader>
  				<ModalBody>
						<span>Are you sure you want to delete this Item?</span>
  				</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.deleteQuoteItem}>Yes</Button>
						<Button color="secondary" className="ml-1" onClick={this.toggle15}>Cancel</Button>
					</ModalFooter>
			  </Modal>
			</div>
      </Fragment>
		);
	}
}

export default QuotingOptions;
